const routes = {
  path: '/equipment',
  component: resolve => require(['../layouts/full/LayoutFull'], resolve),
  children: [
    {
      path: '/equipment',
      name: 'list-equipment',
      component: () => import('../views/Equipment/Index.vue'),
      meta: {
        pageTitle: 'equipment.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'equipment.title', active: true }],
      },
    },
    {
      path: '/equipment/allocations',
      name: 'list-equipment-allocations',
      component: () => import('../views/Equipment/Allocations.vue'),
      meta: {
        pageTitle: 'equipment.allocations.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'equipment.allocations.title', active: true }],
      },
    },
    {
      path: '/equipment/:id/history',
      name: 'equipment-history',
      component: () => import('../views/Equipment/History.vue'),
      meta: {
        pageTitle: 'equipment.history.title',
        access_nivel: ['1'],
        breadcrumb: [
          { text: 'equipment.title', to: { name: 'list-equipment' } },
          { text: 'equipment.history.title', active: true },
        ],
      },
    },
    {
      path: '/equipment/types',
      name: 'list-equipment-types',
      component: () => import('../views/Equipment/Types.vue'),
      meta: {
        pageTitle: 'equipment.types.title',
        access_nivel: ['1'],
        breadcrumb: [{ text: 'equipment.types.title', active: true }],
      },
    },
  ],
}

export default routes
